import classes from '../../../../../styles/Overview.module.css';
import React, { useContext, useEffect, useState } from 'react';
import { START_LOADER, STOP_LOADER } from '../../../../../constants';
import { DataHubServiceRoot } from '../../../../../services/DataHubService';
import { LoaderContext } from '../../../../../context/LoaderContext';
import moment from 'moment';
import { usToEuCurrencyFormat } from '../../../../../utils/currencyHelper';
import { truncateNumber } from '../../../../../utils/numberHelper';
import { momentTimeFormater, toCET } from '../../../../../utils/timeHelper';
import { DownloadAsExcel } from '../../../../../utils/downloadAsExcel';
import Typography from '../../../../../components/Typography/Typography';
import DownloadButton from '../../../../../components/Buttons/DownloadButton';
import { timeOnly } from '../../../../../utils/dateHelper';
import DatePicker from '../../../../../components/Inputs/DatePicker/DatePicker';
import { toast } from 'react-toastify';
import EChart from '../../../../../components/Echarts/Echarts';
import TabsComponent from '../../../../../components/Tabs/Tabs';
import _ from 'lodash';

const today = new Date();

const Overview = ({ device, updateQueryParams, queryParamsData }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });

    const [date, setDate] = useState(queryParamsData?.date || null);
    const [selectedIndex, setSelectedIndex] = useState(queryParamsData?.subTab || 0);
    const [overviewGraphData, setOverviewGraphData] = useState([]);
    const [priceGraphData, setPriceGraphData] = useState([]);
    const [lastStatus, setLastStatus] = useState('--');
    const [isParams, setIsParams] = useState(queryParamsData?.date ? true : false);
    useEffect(() => {
        if (device.id && date) {
            const processedDate = moment(date).format('YYYY-MM-DD');
            DataHubServiceRoot.readGraphData(
                device.id,
                {
                    date: processedDate,
                    priceSignal: device.priceSignal,
                    taxValue: device.taxValue,
                },
                () => startLoader('readGraphData'),
                handleReadSuccess,
                handleError,
                () => stopLoader('readGraphData')
            );
        }
    }, [date]);

    useEffect(() => {
        if (device.id)
            DataHubServiceRoot.readLastStatus(
                device.id,
                () => startLoader('readLastData'),
                handleReadLastStatusSuccess,
                handleError,
                () => stopLoader('readLastData')
            );
    }, [device]);

    useEffect(() => {
        updateQueryParams('date', date);
    }, [date]);

    const handleReadLastStatusSuccess = ({ data }) => {
        if (data.data?.startTime) {
            const date = momentTimeFormater(data.data?.startTime).format('YYYY-MM-DD');
            if (!isParams) {
                setDate(moment(date).toDate());
            }
            setLastStatus(date);
        } else {
            if (!isParams) {
                setDate(today);
            }
            setLastStatus('--');
        }
        setIsParams(false);
    };

    const handleReadSuccess = ({ data }) => {
        const { overview, price } = data.data.graph;
        const processedOverviewData = overview.map((mydata) => {
            return {
                ...mydata,
                type: mydata.name === 'Cost' ? 'line' : 'bar',
                ...(mydata.name === 'Cost' ? { showSymbol: true } : {}),
            };
        });
        const processedPriceData = [{ ...price[0], type: 'bar', showSymbol: true }];
        setOverviewGraphData(processedOverviewData);
        setPriceGraphData(processedPriceData);
    };

    const handleExport = () => {
        const type = selectedIndex === 0 ? 'overview' : 'price';
        if (type === 'overview') {
            if (overviewGraphData[0]?.data?.length) {
                const combinedData = overviewGraphData[0].data?.map((item, index) => ({
                    a: toCET(_.get(item, [0])),
                    b: formatYAxisValue(_.get(item, [1])),
                    c: formatYAxisValue(_.get(overviewGraphData, [1, 'data', index, 1])),
                }));
                overviewGraphData[0]?.data?.length &&
                    DownloadAsExcel(combinedData, `Datahub ${moment(date).tz('Europe/Berlin').format('YYYY-MM-DD')} Export`, [
                        'Date & Time (CET)',
                        'Cost (DKK)',
                        'Consumption (kWh)',
                    ]);
            }
        } else if (type === 'price') {
            if (priceGraphData[0]?.data?.length) {
                const combinedData = priceGraphData[0].data?.map((item, index) => ({
                    a: toCET(_.get(item, [0])),
                    b: formatYAxisValue(_.get(item, [1])),
                }));
                priceGraphData[0]?.data?.length &&
                    DownloadAsExcel(combinedData, `Datahub ${moment(date).tz('Europe/Berlin').format('YYYY-MM-DD')} Export Price`, ['Date & Time (CET)', 'Price (DKK)']);
            }
        }
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const formatYAxisValue = (value) => {
        return usToEuCurrencyFormat(value, 2);
    };

    let tabs = [
        {
            name: 'Overview',
            component: (
                <div>
                    <EChart series={overviewGraphData} xFormatter={(x) => timeOnly(momentTimeFormater(x))} yFormatter={formatYAxisValue} yTooltipSuffix={['kr', 'kWh']} />
                </div>
            ),
            tabId: 0,
        },
        {
            name: 'Prices',
            component: <EChart series={priceGraphData} xFormatter={(x) => timeOnly(momentTimeFormater(x))} yFormatter={formatYAxisValue} yTooltipSuffix={['kr']} />,
            tabId: 1,
        },
    ];

    return (
        <div className={classes.Overview} style={{ height: '31vw' }}>
            <div className={classes.ChartContainer}>
                <div>
                    <div className={classes.Header}>
                        <div>
                            {/* <img
                src={SettingsIcon}
                alt=""
                onClick={() => {
                  handleOpen(device);
                  setEditDevice({ ...device });
                }}
              /> */}
                            <Typography content={`Meter name: ${device?.name || ' -- '}`} />
                            <Typography content={`Meter ID: ${device.id || ' -- '}`} />
                            <Typography subtext content={'Last Reported: ' + (lastStatus || '--')} />
                        </div>
                        <div className={classes.Actions}>
                            <DatePicker date={date} setDate={setDate} showArrow />
                            <DownloadButton size="medium" onClick={() => handleExport()} />
                        </div>
                    </div>
                    <div className={classes.OverviewBorder}></div>
                </div>
                <div className={classes.TabsContainer}>
                    <TabsComponent
                        selectedIndex={selectedIndex}
                        tabs={tabs}
                        onChangeTab={(e) => {
                            setSelectedIndex(e);
                            updateQueryParams('subTab', e);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Overview;
